import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { DatePickerTitle, FormWidgetsTitle } from "../../../../../Constants/Constants";
import DatePicker from "./DatePicker/DatePicker";
import DefaultCalendar from "./DefaultCalendar";
import ReactstrapCalendar from "./ReactstrapCalendar";
import TimePicker from "./TimePicker/TimePicker";
import { Fragment } from "react/jsx-runtime";

const DatePickerContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={DatePickerTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <Row>
          <DefaultCalendar />
          <ReactstrapCalendar />
          <DatePicker />
          <TimePicker />
        </Row>
      </Container>
    </Fragment>
  );
};

export default DatePickerContainer;
